import fb from "@bd-core/firebase";

export const getAttributes = () => {
    return fb.get(`${fb.teamAttributesPath}`);
};

export const updateAttributes = (data) => {
    return fb.update(`${fb.teamAttributesPath}`, data);
};

export const getShouldFinishedAttribute = () => {
    return fb.get(`${fb.teamAttributesPath}/shouldFinishAt`);
};

export const updateShouldFinishedAttribute = (data) => {
    return fb.update(`${fb.teamAttributesPath}/shouldFinishAt`, data);
};

export const saveFinalRoomAnswers = (roomId, answers) => {
    return fb.update(`${fb.roomsPath}/${roomId}`, {
        finalAnswers: answers,
    });
};

export const updateFinalRoomAnswer = (roomId, answer) => {
    return fb.update(`${fb.roomsPath}/${roomId}/finalAnswers`, answer);
};

export const getFinalRoomAnswers = (roomId) => {
    return fb.get(`${fb.roomsPath}/${roomId}/finalAnswers`);
};

export const updateRoomAnswer = (roomId, answers) => {
    return fb.update(`${fb.roomsPath}/${roomId}/answers`, answers);
};

export const updateBudget = (amount, type) => {
    return fb.update(`${fb.teamAttributesPath}`, {
        [type]: amount,
    });
};

export const getBudget = (type) => {
    return fb.get(`${fb.teamAttributesPath}/${type}Budget`);
};

export const removeRoomAnswer = (roomId, key) => {
    let path = `${fb.roomsPath}/${roomId}/answers`;
    if (key) path += `/${key}`;
    return fb.remove(path);
};

export const removeRoomAnswers = () => {
    return fb.remove(`${fb.roomsPath}`);
};

export const getRoomAnswers = (roomId) => {
    return fb.get(`${fb.roomsPath}/${roomId}/answers`);
};

export const maybeUpdateRoomStatus = (roomId, roomStatus) => {
    return fb.update(`${fb.roomsPath}/${roomId}`, {
        status: roomStatus,
    });
};

export const setAllRoomIsCompleted = (isAllRoomcompleted) => {
    return fb.update(`${fb.teamAttributesPath}`, {
        allRoomIsCompleted: isAllRoomcompleted,
    });
};

export const updatePlayerPageId = (pageId) => {
    return fb.update(`${fb.currentPlayerPath}`, {
        currentPageId: pageId,
    });
};

export const setMiddleState = (roomId) => {
    fb.update(`${fb.teamAttributesPath}`, { isMiddleState: true });
    fb.update(`${fb.roomsPath}/${roomId}`, { isMiddleState: true });
};

export const updateisUsingTobyHint = (roomId) => {
    return fb.update(`${fb.roomsPath}/${roomId}`, { isUsingTobyHint: true });
};

export const updateProfileFirebase = (data) => {
    return fb.update(fb.currentPlayerPath, data);
};

export const updateTeamConnectorState = (data) => {
    return fb.update(`${fb.teamAttributesPath}/teamconnector`, data);
};

export const updateHintIsOpened = (roomId, userId, hintId) => {
    return fb.update(`${fb.roomsPath}/${roomId}/hints/${userId}`, {
        [hintId]: true,
    });
};
